module.exports = __webpack_public_path__ + "static/media/background.94320977.jpg";